<template>
  <div class="transportationInformationView">
    <el-form
      label-position="right"
      :model="shippingMethod"
      ref="shippingMethod"
      label-width="120px"
    >
      <el-row>
        <el-col :span="6">
          <el-form-item
            :label="$t('logistics.transportationInformation.shippingMethod')"
            prop="shippingMethod"
          >
            <el-select
              v-model="shippingMethod.shippingMethod"
              filterable
              :placeholder="$t('logistics.transportationInformation.pleaseShippingMethod')"
              disabled
            >
              <el-option
                v-for="item in isInsureTypeList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <vxe-grid
      border
      size="mini"
      :auto-resize="true"
      resizable
      :columns="tableColumn"
      :data="transportationInformationData"
    ></vxe-grid>
  </div>
</template>
<script>
  import API from '@/api/logisticsCenter/logisticsReceiptList.js';
  export default {
    name: 'transportationInformationView',
    props: ['transportationInformationData', 'shippingMethod'],
    data() {
      return {
        isInsureTypeList: [],
        tableColumn: [
          {
            type: 'index',
            title: this.$t('logistics.transportationInformation.index'),
            width: 120,
          },
          {
            field: 'nameVoyageLicense',
            title: this.$t('logistics.transportationInformation.nameVoyageLicense'),
          },
          {
            field: 'shippingInfo',
            title: this.$t('logistics.transportationInformation.shippingInfo'),
          },
          {
            field: 'chargePerson',
            title: this.$t('logistics.transportationInformation.chargePerson'),
          },
          {
            field: 'contactInfo',
            title: this.$t('logistics.transportationInformation.contactInfo'),
          },
          {
            field: 'identityCardNumber',
            title: this.$t('logistics.transportationInformation.identityCardNumber'),
          },
        ],
        shippingMethods: {},
      };
    },
    mounted() {
      this.getBusinessType();
    },
    methods: {
      getSaveVal() {
        let object = {
          transportationInformationData: this.transportationInformationData,
          shippingMethod: this.shippingMethod,
        };
        return object;
      },
      //获取运输方式
      async getBusinessType() {
        let params = {
          dictType: 'delivery_method',
        };
        const selectStatus = await this.$axios.post(API.LISTDATA_DICTBYDATACODE, params);
        if (selectStatus.data.code == 0) {
          this.isInsureTypeList = selectStatus.data.data;
        }
      },
    },
  };
</script>
<style lang="scss" scoped></style>
